import { trans } from "@mongez/localization";
import { getPageService } from "core/informative-pages";
import { pageHead } from "framework/config/meta";
import { publicRoutes } from "framework/config/middlewares";

export const loader = publicRoutes(async ({ http, success, catchErrors }) => {
  try {
    const res = await getPageService(http, "privacy-policy");

    return success(res);
  } catch (error) {
    return catchErrors(error);
  }
});

export function meta() {
  return pageHead({
    title: trans("privacyPolicy"),
    appendAppName: true,
  });
}
